import { createTypedOutlet } from "src/router";

import type { SyncRunQuery } from "src/graphql";
import type { Sync } from "src/pages/syncs/sync/utils/types";

export type SyncRunOutletContext = {
  sync: Sync;
  syncRequest: NonNullable<SyncRunQuery["sync_requests_by_pk"]>;
};

const {
  OutletProvider: SyncRunOutlet,
  useContext: useSyncRunOutletContext,
  useOptionalContext: useSyncRunOutletContextIfAvailable,
} = createTypedOutlet<SyncRunOutletContext>("SyncRun");

export {
  SyncRunOutlet,
  useSyncRunOutletContext,
  useSyncRunOutletContextIfAvailable,
};
